import { DefaultTheme, ThemeProps } from 'styled-components';
import { TextPresetKey } from '@optimus-web/local-tokens';
import '@optimus-web/theme';
import { rem } from './rem';

interface TextPresetOptions {
    uniformLineHeight?: boolean;
}

export const getTextPresetCss =
    (presetId: TextPresetKey, { uniformLineHeight }: TextPresetOptions = {}) =>
    (props: ThemeProps<DefaultTheme>) => {
        if (!props.theme.textPresets) {
            return;
        }

        const { fontSize, fontWeight, lineHeight } = props.theme.textPresets[presetId];
        const { rootSize } = props.theme.settings;
        const { fontFamily } = props.theme.typography;

        return `
            font-family: ${fontFamily};
            font-size: ${rem({ size: fontSize, rootSize })};
            font-weight: ${fontWeight};
            line-height: ${uniformLineHeight ? '1' : lineHeight};
        `;
    };
